// @ts-expect-error Could not find a declaration file for module
import FormattedDuration from 'I18n/components/FormattedDuration';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import ACInProgressDot from 'academy-common-lib/components/card/ACInProgressDot';
import styled from 'academy-common-lib/utils/Styling';
import { Box } from 'foundations-components/transitional/components/Box';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedList from 'I18n/components/FormattedList';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InProgressLargeCardDot = styled(ACInProgressDot).withConfig({
  displayName: "ACLearningContentTimeReadout__InProgressLargeCardDot",
  componentId: "teogz0-0"
})(["bottom:-9px;margin-left:3px;margin-right:9px;"]);
export const ACShortTimeReadout = ({
  duration,
  progress
}) => {
  if (progress === undefined || (progress === null || progress === void 0 ? void 0 : progress.status) === 'COMPLETED') return null;
  return /*#__PURE__*/_jsx(TFlex, {
    children: /*#__PURE__*/_jsx(FormattedDuration, {
      from: Date.now() - duration * 1000
    })
  });
};
export const ACLessonTimeReadout = ({
  duration,
  progress
}) => {
  if (progress === undefined || (progress === null || progress === void 0 ? void 0 : progress.status) === 'COMPLETED') return null;
  const {
    status,
    remainingDuration
  } = progress || {};
  const showProgress = !!remainingDuration && status === 'IN_PROGRESS';
  return /*#__PURE__*/_jsx(TFlex, {
    children: showProgress ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(InProgressLargeCardDot, {}), /*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "academyCommon.tracks.timeRemaining.duration",
          options: {
            duration: /*#__PURE__*/_jsx(FormattedDuration, {
              from: Date.now() - remainingDuration * 1000
            })
          }
        })
      })]
    }) : /*#__PURE__*/_jsx(Box, {
      children: /*#__PURE__*/_jsx(FormattedDuration, {
        from: Date.now() - duration * 1000
      })
    })
  });
};
export const ACTrackTimeReadout = ({
  duration,
  progress,
  totalItems
}) => {
  if (progress === undefined || (progress === null || progress === void 0 ? void 0 : progress.status) === 'COMPLETED') return null;
  const {
    status,
    remainingDuration,
    completedLessonIds
  } = progress || {};
  const remainingLessons = totalItems - ((completedLessonIds === null || completedLessonIds === void 0 ? void 0 : completedLessonIds.length) || 0);
  const showProgress = !!remainingDuration && status === 'IN_PROGRESS';
  return /*#__PURE__*/_jsx(TFlex, {
    children: showProgress ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(InProgressLargeCardDot, {}), /*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsxs(FormattedList, {
          exclusive: true,
          children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
            "data-test-id": "track-total-lessons",
            message: "academyCommon.reducedContentCards.numLessonsRemaining",
            options: {
              remainingNumber: remainingLessons,
              totalNumber: totalItems
            }
          }), /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "academyCommon.tracks.timeRemaining.duration",
            options: {
              duration: /*#__PURE__*/_jsx(FormattedDuration, {
                from: new Date().getTime() - remainingDuration * 1000
              })
            }
          })]
        })
      })]
    }) : remainingLessons > 0 && /*#__PURE__*/_jsxs(List, {
      inline: true,
      use: "inline-divided",
      children: [/*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          "data-test-id": "track-total-lessons",
          message: "academyCommon.reducedContentCards.numLessonsRemainingNotStarted",
          options: {
            remainingNumber: remainingLessons
          }
        })
      }), /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(FormattedDuration, {
          from: Date.now() - duration * 1000
        })
      })]
    })
  });
};
export const ACPlaylistTimeReadout = ({
  progress,
  totalItems
}) => {
  if (progress === undefined || (progress === null || progress === void 0 ? void 0 : progress.status) === 'COMPLETED') return null;
  const {
    status,
    completedItemsCount
  } = progress || {};
  const showProgress = !!completedItemsCount && status === 'IN_PROGRESS';
  return /*#__PURE__*/_jsx(TFlex, {
    children: showProgress ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(InProgressLargeCardDot, {}), /*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsx(FormattedList, {
          exclusive: true,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyCommon.reducedContentCards.numItemsRemaining",
            options: {
              remainingNumber: totalItems - completedItemsCount,
              totalNumber: totalItems
            }
          })
        })
      })]
    }) : /*#__PURE__*/_jsx(Box, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyCommon.reducedContentCards.items",
        options: {
          itemsCount: totalItems
        }
      })
    })
  });
};
export const ACLearningContentTimeReadout = ({
  item
}) => {
  const {
    type
  } = item;
  switch (type) {
    case 'SHORT_FORM_CONTENT':
      {
        const {
          progress,
          duration
        } = item;
        return /*#__PURE__*/_jsx(ACShortTimeReadout, {
          duration: duration,
          progress: progress
        });
      }
    case 'LESSON':
      {
        const {
          progress,
          duration
        } = item;
        return /*#__PURE__*/_jsx(ACLessonTimeReadout, {
          duration: duration,
          progress: progress
        });
      }
    case 'TRACK':
      {
        const {
          lessonIds,
          progress,
          duration
        } = item;
        return /*#__PURE__*/_jsx(ACTrackTimeReadout, {
          duration: duration,
          progress: progress,
          totalItems: lessonIds.length
        });
      }
    case 'PLAYLIST':
    case 'LEARNING_PATH':
      {
        const {
          progress,
          itemsCount
        } = item;
        return /*#__PURE__*/_jsx(ACPlaylistTimeReadout, {
          progress: progress,
          totalItems: itemsCount
        });
      }
    default:
      return null;
  }
};